import React, { useEffect, useState } from 'react';
import { Box, Button, Modal, IconButton } from '@material-ui/core';
import BuzzTable from '../../../components/BuzzTable/BuzzTable';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/DeleteOutline';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import useToast from '../../../hooks/useToast';
import useLoader from '../../../hooks/useLoader';
import CustomForm from '../../../components/FormRenderer/CustomForm';
import { initializeFormData } from '../../../components/FormRenderer/utils';
import {
  createAkademyClass,
  deleteAkademyClass,
  getAllAkademyClasses,
  updateAkademyClass,
} from '../AkademySlice';

const AkademyClasses = () => {
  const dispatch = useDispatch();
  const { ErrorToast, SuccessToast } = useToast();
  const { handleLoader } = useLoader();

  const [showFormModal, setFormModal] = useState(false);
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [formTemplate, setFormTemplate] = useState(null);
  const [formData, setFormData] = useState({});

  const { classes } = useSelector(({ akademyReducer }) => {
    return {
      classes: akademyReducer.classes,
    };
  });

  useEffect(() => {
    dispatch(getAllAkademyClasses());
  }, []);

  useEffect(() => {
    if (selectedRowId) {
      let newFormData = JSON.parse(
        JSON.stringify(classes.filter((item) => item._id === selectedRowId)[0])
      );
      setFormData(newFormData);
    } else setFormData(initializeFormData(formTemplate));
  }, [selectedRowId]);

  useEffect(() => {
    const formTemplate = [
      {
        id: 'form.name',
        title: 'Name',
        slug: 'name',
        type: 'String',
        placeholder: 'Ex: Class IK1',
        required: true,
      },
      {
        id: 'form.code',
        title: 'Code',
        slug: 'code',
        type: 'String',
        placeholder: 'Ex: IK1',
        required: true,
      },
      {
        id: 'form.description',
        title: 'Description',
        slug: 'description',
        type: 'String',
        required: false,
      },
    ];
    setFormTemplate(formTemplate);
    setFormData(initializeFormData(formTemplate));
  }, []);

  const classColumns = [
    { Header: 'Class Id', accessor: '_id' },
    { Header: 'Code', accessor: 'code' },
    { Header: 'Name', accessor: 'name' },
    { Header: 'Description', accessor: 'description' },
    {
      Header: 'Action',
      Cell: (val) => {
        const { _id } = val.cell.row.original;

        return (
          <>
            <IconButton onClick={() => handleEdit(_id)}>
              <EditIcon color="secondary" />
            </IconButton>
            <IconButton onClick={() => handleDeletion(_id)}>
              <DeleteIcon color="primary" />
            </IconButton>
          </>
        );
      },
    },
  ];

  const openFormModal = () => setFormModal(true);
  const closeFormModal = () => setFormModal(false);

  const handleEdit = (id) => {
    setSelectedRowId(id);
    openFormModal();
  };

  const handleCreateNew = () => {
    setSelectedRowId(null);
    openFormModal();
  };

  const handleDeletion = async (id) => {
    setSelectedRowId(id);

    if (!window.confirm('Are you sure ?')) return;

    dispatch(deleteAkademyClass({ id }))
      .unwrap()
      .then((res) => {
        console.log(res);
        SuccessToast(res.message);
        dispatch(getAllAkademyClasses());
      })
      .catch((error) => {
        console.error('rejected', error);
        ErrorToast(error.message);
      });
  };

  const handleSave = async () => {
    handleLoader(true);
    let payload = formData;

    dispatch(
      selectedRowId === null
        ? createAkademyClass(payload)
        : updateAkademyClass({ id: selectedRowId, data: payload })
    )
      .unwrap()
      .then((res) => {
        console.log(res);
        SuccessToast(res.message);
        dispatch(getAllAkademyClasses());
        closeFormModal();
      })
      .catch((error) => {
        console.error('rejected', error);
        ErrorToast(error.message);
      });

    handleLoader(false);
  };

  return (
    <Box>
      <Button onClick={handleCreateNew} variant={'contained'} color="primary">
        Add Class
      </Button>
      <Box my={2}>
        <BuzzTable columns={classColumns} data={classes} />
      </Box>
      <Modal open={showFormModal} onClose={closeFormModal}>
        <CustomForm
          formFor={'Class'}
          formTemplate={formTemplate}
          formData={formData}
          setFormData={(slug, newValue) => {
            setFormData((state) => {
              state[slug] = newValue;
              return state;
            });
            setFormTemplate((state) => {
              return JSON.parse(JSON.stringify(state));
            });
          }}
          mode={selectedRowId === null ? 'CREATE' : 'EDIT'}
          handleSave={handleSave}
        />
      </Modal>
    </Box>
  );
};

export default AkademyClasses;
